<template>
  <div>
    <!-- Description list with inline editing -->
    <div class="m-10 divide-y divide-gray-200">
      <div class="space-y-1">
        <h3 class="text-lg leading-6 font-medium text-light-body-text dark:text-dark-body-text">
          {{ $t("Cannot fetch this") }} {{ objectType }}!
        </h3>
        <p class="max-w-2xl text-sm pt-5 text-light-body-text dark:text-dark-body-text">
          {{ $t("You do not have access to this") }} {{ objectType }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    objectType: {
      type: String,
      required: true
    }
  }
}
</script>
